import { cn } from "@/lib/utils";

type PageContainerProps = React.HTMLAttributes<HTMLDivElement> & {
  /**
   * Replaces the default padding around the content column, which is the marketing pages' own:
   * none on phones, then `p-3` from `sm`, `p-6` from `md` and `p-4` from `lg`.
   */
  paddingClassName?: string;
};

export function PageContainer({
  className,
  paddingClassName = "sm:p-3 md:p-6 lg:p-4",
  children,
  ...props
}: PageContainerProps) {
  return (
    <div className={cn("flex w-full flex-col items-center", className)} {...props}>
      <div className={cn("w-full", paddingClassName)}>
        <div className="mx-auto flex w-full max-w-[var(--layout-page-container-max-width)] flex-col gap-section-stack">
          {children}
        </div>
      </div>
    </div>
  );
}
